module.exports = __webpack_public_path__ + "579d02bf4453dae80334f399a7a10751-nei_home_30_2x.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/home/assets/nei_home_30_2x.png
// module id = 625
// module chunks = 0